(function () {
  function setupScrollVideo() {
    const section = document.querySelector('.ityre-scroll-film');
    const video = document.querySelector('[data-scroll-video]');
    if (!section || !video) return;
    let frame = 0;
    let metadataReady = false;
    const sync = () => {
      const rect = section.getBoundingClientRect();
      const viewport = window.innerHeight || document.documentElement.clientHeight || 1;
      const scrollable = Math.max(1, rect.height - viewport);
      const progress = Math.min(1, Math.max(0, -rect.top / scrollable));
      section.style.setProperty('--scroll-progress', progress.toFixed(4));
      if (metadataReady && Number.isFinite(video.duration) && video.duration > 0) {
        const targetTime = Math.min(video.duration - 0.08, Math.max(0.08, progress * video.duration));
        if (Math.abs(video.currentTime - targetTime) > 0.018) {
          try {
            if (typeof video.fastSeek === 'function') video.fastSeek(targetTime);
            else video.currentTime = targetTime;
          } catch (error) {
            section.classList.add('ityre-scroll-video-pending');
          }
        }
      }
    };
    const schedule = () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(sync);
    };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    video.addEventListener('loadedmetadata', () => {
      metadataReady = true;
      video.pause();
      schedule();
    });
    video.addEventListener('canplay', schedule);
    video.load();
    video.play().then(() => video.pause()).catch(() => {});
    schedule();
  }

  function setupLanguageSwitching() {
    const legacyItems = Array.from(document.querySelectorAll('.ityre-language-toggle a:not([data-ityre-lang]), .ityre-language-toggle button:not([data-ityre-lang])'));
    legacyItems.forEach((item) => {
      const label = item.textContent.trim().toLowerCase();
      item.setAttribute('data-ityre-lang', label.includes('it') ? 'it' : label.includes('中') ? 'zh' : 'en');
      if (item.tagName === 'A') item.setAttribute('role', 'button');
    });
    const buttons = Array.from(document.querySelectorAll('[data-ityre-lang]'));
    if (!buttons.length) return;
    const translations = {
      en: {
        navShop: 'Shop tyres',
        navSummer: 'Summer',
        navHelp: 'Help',
        cartLabel: 'Cart',
        searchPlaceholder: 'Search tyres, sizes...',
        faqTitle: 'Tyre questions answered',
        faqIntro: 'Clear answers for size, labels, returns, payment safety and stock changes.',
        toolsKicker: 'Buyer tools',
        toolsTitle: 'Quick checks before choosing a tyre.',
        viewTyre: 'View tyre',
        compare: 'Compare'
      },
      it: {
        navShop: 'Pneumatici',
        navSummer: 'Estate',
        navHelp: 'Aiuto',
        cartLabel: 'Carrello',
        searchPlaceholder: 'Cerca gomme, misure...',
        faqTitle: 'Domande sui pneumatici',
        faqIntro: 'Risposte chiare su misure, etichette, resi, pagamenti e disponibilita.',
        toolsKicker: 'Guide acquisto',
        toolsTitle: 'Controlli rapidi prima della scelta.',
        viewTyre: 'Vedi gomma',
        compare: 'Confronta'
      },
      zh: {
        navShop: '轮胎商城',
        navSummer: '夏季',
        navHelp: '帮助',
        cartLabel: '购物车',
        searchPlaceholder: '搜索轮胎和尺寸...',
        faqTitle: '轮胎问题解答',
        faqIntro: '关于尺寸、标签、退货、支付安全和库存变化的清晰答案。',
        toolsKicker: '购买工具',
        toolsTitle: '选择轮胎前的快速检查。',
        viewTyre: '查看轮胎',
        compare: '比较'
      }
    };
    const setLang = (lang) => {
      const dict = translations[lang] || translations.en;
      document.documentElement.lang = lang === 'zh' ? 'zh-CN' : lang;
      buttons.forEach((button) => {
        const active = button.dataset.ityreLang === lang;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      document.querySelectorAll('[data-i18n]').forEach((node) => {
        const key = node.getAttribute('data-i18n');
        if (dict[key]) node.textContent = dict[key];
      });
      document.querySelectorAll('.ityre-header nav a').forEach((link) => {
        const text = link.textContent.trim().toLowerCase();
        if (/shop tyres|pneumatici|轮胎商城/.test(text)) link.textContent = dict.navShop;
        if (/summer|estate|夏季/.test(text)) link.textContent = dict.navSummer;
        if (/help|aiuto|帮助/.test(text)) link.textContent = dict.navHelp;
      });
      document.querySelectorAll('.ityre-cart').forEach((cart) => {
        const count = cart.querySelector('span:last-child')?.textContent?.trim() || '';
        if (!cart.querySelector('[data-i18n="cartLabel"]')) cart.innerHTML = `<span data-i18n="cartLabel">${dict.cartLabel}</span> <span>${count}</span>`;
      });
      document.querySelectorAll('.ityre-site-search input, .ityre-state-panel input[name="q"]').forEach((input) => {
        input.setAttribute('placeholder', dict.searchPlaceholder);
      });
      const faqHeading = document.querySelector('.ityre-faq-preview-copy h2, .ityre-faq-hero h1');
      if (faqHeading && dict.faqTitle) faqHeading.textContent = dict.faqTitle;
      const faqIntro = document.querySelector('.ityre-faq-preview-copy p:not(.ityre-kicker), .ityre-faq-hero p');
      if (faqIntro && dict.faqIntro) faqIntro.textContent = dict.faqIntro;
      const toolsKicker = document.querySelector('.ityre-tools .ityre-kicker');
      if (toolsKicker) toolsKicker.textContent = dict.toolsKicker;
      const toolsTitle = document.querySelector('.ityre-tools .ityre-section-title h2');
      if (toolsTitle) toolsTitle.textContent = dict.toolsTitle;
      document.querySelectorAll('.ityre-card-actions a').forEach((link) => {
        if (/view tyre|vedi gomma|查看轮胎/i.test(link.textContent.trim())) link.textContent = dict.viewTyre;
      });
      document.querySelectorAll('.ityre-card-actions label').forEach((label) => {
        const input = label.querySelector('input');
        label.childNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) node.textContent = ` ${dict.compare}`;
        });
        if (!label.textContent.trim().includes(dict.compare) && input) label.append(` ${dict.compare}`);
      });
      try {
        window.localStorage.setItem('instatyre-language', lang);
      } catch (error) {}
    };
    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        setLang(button.dataset.ityreLang);
      });
    });
    let saved = 'en';
    try {
      saved = window.localStorage.getItem('instatyre-language') || 'en';
    } catch (error) {}
    setLang(saved);
  }

  function ensureInstatyreLogo() {
    const logo = document.querySelector('.ityre-logo img');
    if (!logo) return;
    if (!/instatyre-logo\.svg/.test(logo.getAttribute('src') || '')) {
      const current = logo.getAttribute('src') || '';
      const base = current.includes('/assets/')
        ? current.replace(/\/assets\/.*/, '/assets/instatyre-logo.svg')
        : '//instatyre.com/cdn/shop/t/2/assets/instatyre-logo.svg';
      logo.setAttribute('src', base);
      logo.setAttribute('alt', 'Instatyre');
      logo.setAttribute('width', '420');
      logo.setAttribute('height', '140');
    }
    const wrapper = logo.closest('.ityre-logo');
    if (wrapper) {
      wrapper.style.width = 'clamp(132px, 14vw, 188px)';
      wrapper.style.minWidth = '132px';
      wrapper.style.height = '58px';
      wrapper.style.overflow = 'hidden';
    }
    logo.style.width = '100%';
    logo.style.height = '100%';
    logo.style.objectFit = 'contain';
  }

  function restoreBuyerTools() {
    if (document.querySelector('.ityre-tools')) return;
    const faq = document.querySelector('.ityre-faq-preview');
    const productGrid = document.querySelector('.ityre-product-grid');
    if (!faq || !productGrid) return;

    const section = document.createElement('section');
    section.className = 'ityre-tools';
    section.setAttribute('aria-label', 'Tyre buying tools');
    section.innerHTML = `
      <div class="ityre-section-title">
        <p class="ityre-kicker">Buyer tools</p>
        <h2>Quick checks before choosing a tyre.</h2>
        <p>Small guidance panels help shoppers read the sidewall, compare EU labels, think through season choice and prepare for fitting or delivery.</p>
      </div>
      <div class="ityre-tool-grid">
        <article class="ityre-widget">
          <h3>Sidewall reader</h3>
          <p>Use the printed tyre code to confirm the correct fitment before placing the order.</p>
          <div class="ityre-sidewall-diagram" aria-label="Example tyre code 205 slash 55 R16 91V">
            <span>205</span><span>55</span><span>R16</span><span>91</span><span>V</span>
          </div>
          <ul class="ityre-checklist">
            <li>Width, profile and rim must match.</li>
            <li>Load and speed must meet vehicle requirements.</li>
          </ul>
        </article>
        <article class="ityre-widget">
          <h3>EU label guide</h3>
          <p>Compare the core label values before choosing between similar tyres.</p>
          <div class="ityre-label-stack" aria-label="EU label examples">
            <span>Fuel B</span><span>Wet A</span><span>69 dB</span>
          </div>
          <ul class="ityre-checklist">
            <li>Wet grip affects rain-road braking.</li>
            <li>Noise matters for EV and motorway comfort.</li>
          </ul>
        </article>
        <article class="ityre-widget ityre-tread-widget">
          <h3>Season check</h3>
          <p>Match the tyre category to climate, mileage and driving profile.</p>
          <label>Driving mix<input type="range" min="1" max="3" value="2" aria-label="Driving mix guide"></label>
          <strong>Balanced: summer, winter or all-season depending on climate.</strong>
        </article>
        <article class="ityre-widget">
          <h3>Fitting prep</h3>
          <p>Before delivery or fitting, keep these order details ready.</p>
          <ul class="ityre-checklist">
            <li>Vehicle make, model and registration.</li>
            <li>Selected tyre size and quantity.</li>
            <li>Installer address or preferred delivery address.</li>
            <li>Order number after checkout.</li>
          </ul>
        </article>
      </div>`;
    faq.parentNode.insertBefore(section, faq);
  }

  document.addEventListener('DOMContentLoaded', () => {
  ensureInstatyreLogo();
    setupScrollVideo();
    restoreBuyerTools();
    setupLanguageSwitching();
  });
})();
